/* Wrapper for the Page Visibility API
   https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
*/

export class PageVisibilityWrapper {
  private _handleVisibilityChange: () => void = () => {}

  constructor(
    private _onPageVisibleCallback: () => void = () => {},
    private _onPageHiddenCallback: () => void = () => {}
  ) {
    /*
      1) Need to bind 'this' so that `this != document`

      2) Bind creates a new function...
        We want to track it, so that can remove the event listener later.
    */
    this._handleVisibilityChange = this.handleVisibilityChange.bind(this)
  }

  init(): void {
    document.addEventListener(
      'visibilitychange',
      this._handleVisibilityChange,
      false
    )
  }

  destroy(): void {
    document.removeEventListener(
      'visibilitychange',
      this._handleVisibilityChange,
      false
    )
  }

  handleVisibilityChange(): void {
    if (document.visibilityState === 'visible') {
      this._onPageVisibleCallback()
    } else {
      this._onPageHiddenCallback()
    }
  }
}
